module.exports = __webpack_public_path__ + "img/CRYPTOCASINO.c1f4a0ce.svg";